import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PasswordRecoverService {

  constructor(private http: HttpClient) { }

  resetPassword(value) {
    return this.http.put(`${environment.protheus}/password-reset`, value);
  }

  requestResetPassword(id, value) {
    const endpoint = `${environment.protheus}/usuarios/` + `${id}/password`;
    return this.http.put(endpoint, value);
  }
}
